import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsXdadevelopersComponent } from './simple-icons-xdadevelopers.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsXdadevelopersComponent ],
    exports:      [ SimpleIconsXdadevelopersComponent ],
    bootstrap:    []
})
export class SimpleIconsXdadevelopersModule {}
